<template>
    <div component="AccordionItem">
        <slot></slot>
        <div block="logo">
            <slot name="logo"></slot>
        </div>
        <div block="circles">
            <slot name="circles"></slot>
        </div>
        <div block="next">
            <slot name="next"></slot>
        </div>
        <div block="bg">
            <slot name="bg"></slot>
        </div>
        <div block="visualizer">
            <slot name="visualizer"></slot>
        </div>
    </div>
</template>
<script>
import { mapGetters, mapActions } from 'vuex';
import Container from '@/mock/Container.vue';
//import Velocity from 'velocity-animate';

export default {
    name: 'AccordionItem',

    props: {},

    computed: {},

    mounted() {},

    data() {
        return {};
    },

    methods: {},

    components: {
        Container,
    },
};
</script>
<style lang="less">
@import '~@variables';

[component='AccordionItem'] {
    position: relative;
    .flex-center;
    align-items: flex-end;
    justify-content: flex-start;
    flex-direction: column;
    padding: 20px;

    height: 100%;
    transition: 0.5s;
    .radiusBig;
    overflow: hidden;
    pointer-events: all;
    box-shadow: 0 3px 1px -2px rgba(0, 0, 0, 10%), 0 2px 2px 0 rgba(0, 0, 0, 14%), 0 1px 15px 0 rgba(0, 0, 0, 15%) !important;
    background: linear-gradient(45deg, #e9e9e9 0%, white 100%);

    @media (min-height: 600px) {
        justify-content: center;
    }
}

[component='AccordionItem'] [block='logo'] {
    position: absolute;
    top: 50%;
    left: 50%;
    // transform-origin: left top;
    transform: translate3d(-50%, -50%, 0) scale(0.5);
    transition: 0.7s;
    z-index: 3;

    @media (min-width: 980px) {
        transform: translate3d(-50%, -50%, 0) scale(1);
    }

    @media (min-height: 480px) {
        transform: translate3d(-50%, -50%, 0) scale(0.6);
    }

    @media (min-height: 600px) {
        transform: translate3d(-50%, -50%, 0) scale(0.8);
    }

    @media (max-height: 420px) {
        left: 5%;
        transform-origin: left top;
        transform: scale(0.2) translate3d(0%, -50%, 0);

        [icon='voice'] {
            span {
                display: inline-block;
            }
        }
    }
    @media (max-height: 300px) {
        [icon='about'] {
            flex-direction: row;
        }
    }
}

[component='AccordionItem'] [block='circles'] {
    z-index: 3;
    transition: 1s;
    transition-delay: 0s;
    pointer-events: none;

    opacity: 0;
    transform-origin: right top;
    transform: scale(0.5);
    position: absolute;
    transition-delay: 0s;

    @media (max-width: 980px) {
        top: 12%;
    }

    @media (min-width: 980px) {
        margin-top: 5%;
        display: flex;
        align-items: center;
        right: 7%;
        top: 25%;
    }
}

[component='AccordionItem'] [block='next'] {
    position: absolute;
    z-index: 50;
    width: 100%;
    bottom: 5%;
    height: 50px;
    left: 0;
    pointer-events: none;

    [component='NavButton'] {
        pointer-events: all;
        position: absolute;
        left: 10%;
        transition-delay: 0.2s;
        transition: 0.5s;
        opacity: 0;
        transform: scale(0.2);
        transform: translate3d(0%, 100px, 0);
    }
}

[component='AccordionItem'] [block='visualizer'] {
    width: 100%;
    height: 200px;
    position: absolute;
    bottom: 0;
    left: 0;
    overflow: hidden;
    .flex-row;
    align-items: flex-end;
    justify-content: space-between;
    padding: 0px 30px 30px 30px;
    z-index: 3;
    transition: 1s;
    pointer-events: none;

    @media (min-width: 768px) {
        .radiusBig-l;
    }

    @media (min-width: 980px) {
        // justify-content: center;
    }

    @media (max-width: 767px) and (min-width: 400px) and (max-height: 480px) {
        padding: 30px 30px 30px 200px;
        height: 100%;
    }

    @media (max-width: 499px) and (min-width: 400px) and (max-height: 480px) {
        padding-left: 0;
        padding-right: 30px;
        flex-direction: column;
    }

    [component='visualizer'] {
        position: absolute;
        width: 100%;
        height: 200px;
        left: 0;
        bottom: 0;
    }

    canvas {
        position: absolute;
        bottom: 0;
        left: 0;
        opacity: 0.5;
        height: 200px;
        z-index: -1;

        @media (orientation: landscape) {
            // opacity: 0.4;

            @media (min-width: 769px) {
                .radiusBig-l;
            }
        }
    }

    .holder {
        display: flex;
        align-items: center;

        @media (max-width: 980px) {
            flex-direction: column;
            justify-content: flex-end;
            align-items: flex-end;
        }

        [component='Mp3Player'] {
            margin: 0 !important;
        }
    }

    [component='Mp3Player'] {
        transition: 0.5s;
        pointer-events: all;

        span {
            max-width: 60px;
        }

        i {
            margin: 0 0 0 3px;
        }
    }

    [component='NavButton'],
    button {
        pointer-events: all;
    }
}

[component='AccordionItem'] [block='bg'] {
    position: absolute;
    top: 0;
    left: 0;
    opacity: 0.3;
    z-index: 1;

    .icon {
        position: absolute;
        color: white;
        transform-origin: left bottom;

        font-size: 700px;
        top: 0;
        left: 0;

        &[for='voice'] {
            transform: translate3d(-30%, 0%, 0);
        }

        &[for='music'] {
            transform: translate3d(-30%, 0%, 0);
        }

        &[for='about'] {
            transform: translate3d(-30%, 0%, 0);
        }
    }
}

[component='AccordionItem'].landscape {
}

// --
// SCENES -------------------------------------------------
// -- list (zoznam)

[component='AccordionItem'][scene='list'] {
    [block='bg'] {
        z-index: 1;
        opacity: 0;
        transform: scale(0.8);
        transition: 0.5s;
    }

    [block='next'] {
        [component='NavButton'] {
            opacity: 0;
            transform: translate3d(0%, -100px, 0) scale(1);
        }
    }

    [component='Mp3Player'],
    [component='NavButton'],
    button {
        opacity: 0;
        pointer-events: none;
    }
}

// EXPANDED  ---------------------------- -----------------------------------------------------------------

[component='AccordionItem'][scene='list'].expanded {
    .gradientHomepage;

    [block='logo'] {
        top: 5%;
        left: 5%;
        transform-origin: left top;
        transform: translate3d(0%, 0%, 0) scale(0.6);

        @media (min-width: 520px) {
            top: 50%;
            left: 5%;
            transform: translate3d(0%, -50%, 0) scale(1.1);
        }

        @media (min-width: 768px) {
            top: 20%;
            left: 5%;
            // transform: translate3d(0%, -50%, 0) scale(1.3);
        }

        @media (min-width: 980px) {
            top: 5%;
            left: 5%;
            transform: translate3d(0%, 0, 0) scale(1.3);
        }

        @media (max-height: 399px) and (min-width: 768px) {
            transform: scale(0.8);
        }

        @media (max-width: 767px) and (min-width: 400px) and (max-height: 550px) {
            top: 50%;
            transform: translateY(-50%);
        }
    }

    @media (max-width: 767px) and (min-width: 400px) and (max-height: 550px) and (min-height: 480px) {
        &[for='voice'] [block='logo'] {
            top: 45%;
        }
        &[for='about'] [block='logo'] {
            top: 36%;
        }
    }

    @media (max-width: 767px) and (max-height: 450px) {
        [icon] {
            // width: 100px;
            // height: 100px;
            margin-left: 0;

            .icon {
                font-size: 50px;
            }
        }

        [icon='voice'] .label {
            //	top: 0;
            //left: 52px;
        }
        [icon='music'] .label {
            //	top: 0;
            //left: 12px;
        }
        [icon='about'] .label {
            //left: 49px;
            //bottom: -13px;
        }
    }

    [block='circles'] {
        opacity: 1;
        transition: 1.3s;
        transform: scale(0.7);
        // margin-top: 40px;
        pointer-events: all;
        display: none;

        @media (min-height: 480px) {
            display: flex;
        }

        @media (min-height: 550px) and (orientation: portrait) {
            transform: scale(0.9);
            // margin-top: 60px;
        }

        @media (min-height: 600px) {
            transform: scale(1);
            // margin-top: 0px;
        }
    }

    [component='Mp3Player'],
    [component='NavButton'],
    button {
        opacity: 1;
        pointer-events: all;

        @media (max-width: 767px) and (min-width: 400px) and (max-height: 480px) {
            margin: auto;
        }

        @media (max-width: 499px) and (min-width: 400px) and (max-height: 480px) {
            margin: auto 0;
        }
    }

    [component='NavButton'] {
        @media (max-width: 399px) and (max-height: 480px) {
            margin-bottom: 8px;
        }
    }

    // [component="NavButton"]{
    // 	opacity: 1;
    // 	transform: translate3d(0%, 0px, 0) scale(1);
    // }

    [block='bg'] {
        opacity: 0.27;
        transform: scale(1);
        transition: 1s;
    }

    [component='Icon'] [icon] .label {
        font-size: 18px;
        padding-left: 0px;
    }
}

// ZBALENY ----------------------------

[component='AccordionItem'][scene='list'].collapsed {
    //background: @white;

    @media (max-width: 980px) {
        border-radius: 30px;
    }

    [block='logo'] {
        @media (max-width: 767px) {
            left: 5%;
            transform-origin: left top;
            transform: scale(0.2) translate3d(0%, -50%, 0);

            [icon='voice'] {
                span {
                    display: inline-block;
                }
            }
        }
        @media (max-height: 300px) {
            [icon='about'] {
                flex-direction: row;
            }
        }
    }

    [block='visualizer'] {
        @media (max-width: 767px) {
            height: 130px;

            [component='Mp3Player'] {
                position: absolute;
                width: 50px;
                height: 50px;
                right: 0px;
                bottom: 0px;
                margin: 0;

                pointer-events: all;
                opacity: 1;

                i {
                    width: 30px;
                    height: 30px;
                    min-width: 30px;
                    min-height: 30px;

                    &:after {
                        width: 30px;
                        height: 30px;
                    }
                }

                span {
                    display: none;
                }
            }

            canvas {
                @media (max-width: 979px) {
                    transform: translateY(50%);
                }
            }
        }
    }

    [block='circles'] {
        @media (max-width: 767px) {
            transition-delay: 0s;
        }
    }

    [component='Icon'] {
        @media (max-width: 767px) {
            [icon] {
                display: flex;
                align-items: center;
                width: auto;

                .label {
                    position: relative;
                    transform: none;
                    top: auto;
                    left: auto;
                    bottom: auto;
                    font-size: 75px;
                    padding-left: 20px;
                }

                .icon {
                    top: auto;
                    left: auto;
                    position: relative;
                }
            }

            [icon='voice'],
            [icon='music'] {
                flex-direction: row-reverse;
            }
        }
    }
}

// --
// SCENES -------------------------------------------------
// -- detail

&[for='about'] {
    [block='circles'] {
    }
}

[component='AccordionItem'][scene='detail'] {
    // transform: translate3d(0%, -110%, 0);
    // opacity: 0;
    visibility: hidden;
    background-color: transparent;

    @media (min-width: 980px) {
        border-radius: 20px 0 0 20px;
    }

    @media (max-width: 980px) {
        justify-content: flex-start;
        box-shadow: none !important;
    }

    [block='visualizer'] {
        opacity: 0;
        padding: 0px 30px 30px 30px;
        flex-direction: row;
    }

    [block='logo'] {
        top: 5%;
        left: 5%;
        transform: translate3d(0%, 0%, 0) scale(0.6);
        opacity: 0;
        transition: 0.3s;
        transition-delay: 0s;
    }

    [block='bg'] {
        opacity: 0;
        transform: scale(1.3);
        transition: 1s;
        transition-delay: 0.2s;
    }

    [block='next'] {
        display: none;
    }

    &[selected] {
        transform: translate3d(0%, 0%, 0);
        transition-delay: 0.3s;
        transition: 1s;
        z-index: 500;
        opacity: 1;
        visibility: visible;
        height: 180px;
        .gradientHomepage;

        @media (max-width: 980px) {
            box-shadow: none;
        }

        @media (min-height: 480px) {
            height: 280px;
        }

        @media (min-height: 600px) {
            height: 330px;
        }

        @media (min-width: 768px) {
            height: 100%;
        }

        [block='circles'] {
            pointer-events: all;
            display: none;
            opacity: 1;
            transform: scale(0.7);
            transition-delay: 0.3s;

            @media (min-height: 480px) {
                display: flex;
            }

            @media (min-height: 600px) and (max-width: 980px) {
                transform: scale(0.85);
            }

            @media (min-width: 980px) {
                transform: scale(1);
            }
        }

        [block='bg'] {
            opacity: 0.2;
            transform: scale(1);
        }

        [block='visualizer'] {
            opacity: 1;
        }

        [block='logo'] {
            opacity: 1;
            transform-origin: left top;
            transition: 1s;
            transition-delay: 0.3s;
            transform: translate3d(0%, 0%, 0) scale(0.6);
            top: 10%;

            @media (min-width: 980px) {
                transform: scale(1);
            }

            @media (min-height: 500px) {
                top: 5%;
            }
        }

        [component='Icon'] [icon] .label {
            @media (max-height: 420px) {
                font-size: 40px;
                padding-left: 0px;
            }
        }
    }
}

// --
// SCENES -------------------------------------------------
// -- sub detail

[component='AccordionItem'][scene='subpage'] {
    padding: 15px;
    // transform: translate3d(-110%, 0%, 0);
    opacity: 0;

    &[selected] {
        // transform: translate3d(0%, 0%, 0);
        opacity: 1;
    }

    [block='circles'] {
        pointer-events: none;
    }

    [block='logo'] {
        top: 5%;
        left: 50%;
        transform-origin: left top;
        transform: translate3d(-25%, 0, 0) scale(0.5);

        @media (@portrait) {
            top: 50%;
            left: 5%;
            transform-origin: left top;
            transform: translate3d(0%, -25%, 0) scale(0.5);
        }
    }

    [block='bg'] {
        .icon {
            &[for='voice'] {
                transform: translate3d(-30%, -40%, 0);
            }

            &[for='music'] {
                transform: translate3d(-30%, -20%, 0);
            }

            &[for='about'] {
                transform: translate3d(-30%, -43%, 0);
            }
        }
    }

    [component='Mp3Player'] {
        span {
            text-align: center;
        }

        flex-direction: column;
    }

    [block='visualizer'] {
        align-items: center;
        justify-content: flex-end;
        height: 130px;
        padding: 20px;

        @media (min-width: 980px) {
            justify-content: center;
        }

        [component='visualizer'] {
            height: 130px;

            canvas {
                transform: translateY(50px);
            }
        }

        [component='Mp3Player'] {
            margin: 5px;
        }

        @media (min-width: 768px) {
            flex-direction: column;
            align-items: center;
            justify-content: flex-end;
            height: 250px;

            [component='Mp3Player'] {
            }
        }
    }
}
</style>
